import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminRequest } from '../requests/login/useAdminRequest';

type UseAdminChecker = () => {
  authenticated: boolean;
  loading: boolean;
};

export const useAdminChecker: UseAdminChecker = () => {
  const navigate = useNavigate();
  const { authenticated, loading } = useAdminRequest();

  useEffect(() => {
    if (!authenticated && !loading) {
      navigate('/admin-login');
    }
  }, [authenticated, navigate, loading]);

  return {
    authenticated,
    loading,
  };
};
